/*
 * @Author: fanyanbo
 */
export default {
  props: [],
  computed: {},
  methods: {
    getUpTarget (index) {
      return !this.panel.first ? '' : `#tabIndex${this.tabNum}`
    },
    getRightTarget (index) {
      return '#' + (index < this.panel.itemDetailList.length - 1 ? `panel${this.panelId}_${index + 1}` : `panel${this.panelId}_${this.panel.itemDetailList.length - 1}`)
    },
    getLeftTarget (index) {
      return '#' + (index > 0 ? `panel${this.panelId}_${index - 1}` : `panel${this.panelId}_0`)
    },
    getDownTarget (index) {
      return !this.panel.last ? '' : `#panel${this.panelId}_${index}`
    }
  }
}
